
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { EVENT_TYPES } from "@/lib/constants";

interface EventTypeFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const EventTypeFilter = ({ value, onChange }: EventTypeFilterProps) => {
  const handleValueChange = (newValue: string) => {
    // Convert "all" to empty string for consistency with other filters
    onChange(newValue === "all" ? "" : newValue);
  };

  return (
    <Select value={value || "all"} onValueChange={handleValueChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Event Type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Event Types</SelectItem>
        {EVENT_TYPES.map((type) => (
          <SelectItem key={type} value={type}>
            {type}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
